import { render, staticRenderFns } from "./LookupsTable.vue?vue&type=template&id=4121e53d&scoped=true&"
import script from "./LookupsTable.vue?vue&type=script&lang=js&"
export * from "./LookupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121e53d",
  null
  
)

export default component.exports